"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusBar = void 0;
var core_1 = require("@material-ui/core");
var styled_components_1 = __importDefault(require("styled-components"));
exports.StatusBar = core_1.withTheme(styled_components_1.default(core_1.Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        min-width: 90px;\n        padding: 8px;\n        border-radius: 4px;\n        text-align: center;\n    "], ["\n        min-width: 90px;\n        padding: 8px;\n        border-radius: 4px;\n        text-align: center;\n    "]))));
var templateObject_1;
